import { useQuery } from "@tanstack/react-query";
import { getGroupChats } from "../api/groupChats.api";
import { useAuth } from "./AuthContext";

export const useLoadGroupChats = () => {
  const { user } = useAuth();

  const {
    data: groupChats = [],
    isLoading,
    isError,
  } = useQuery({
    queryFn: getGroupChats,
    queryKey: ["group-chats", user?.id],
    enabled: !!user,
    refetchOnWindowFocus: true,
  });

  return { groupChats, isLoading, isError };
};

